/**
 *
 * @param {window} win Takes the window object (which makes testing easier)
 * @returns True or false depending on if things are running in the test suite
 */
const inTestSuite = (win = false) =>
	win && Object.prototype.hasOwnProperty.call(win, 'test');

export default inTestSuite;
